import { useIntParam, useNavigationContext } from 'hooks';
import { allowedActionsStore } from 'store';

export const useLrwSessionAllowedActions = () => {
  const lrwSessionId = useIntParam('sessionId');
  const { locationId } = useNavigationContext();

  const {
    isLoading,
    isFetching,
    data: allowedActions,
  } = allowedActionsStore.service.useGetAllowedLrwSessionActionsQuery(
    { lrwSessionId, locationId },
    { skip: Number.isNaN(lrwSessionId) }
  );

  return {
    canReleaseLrwSession: allowedActions?.canReleaseLrwSession ?? false,
    canLinkSpeakingSession: allowedActions?.canLinkSpeakingSession ?? false,
    cantLinkSpeakingSessionReasons: allowedActions?.cantLinkSpeakingSessionReasons ?? [],
    canChangeSeatsLimit: allowedActions?.canChangeSeatsLimit ?? false,
    canUpdateLrwSession: allowedActions?.canUpdateLrwSession ?? false,
    canRemoveLrwSession: allowedActions?.canRemoveLrwSession ?? false,
    canAssignRooms: allowedActions?.canAssignRooms ?? false,
    canRemoveRoom: allowedActions?.canRemoveRoom ?? false,
    canUnlinkSpeakingSession: allowedActions?.canUnlinkSpeakingSession ?? false,
    canPrintExamMaterials: allowedActions?.canPrintExamMaterials ?? false,
    canUpdateSalesChannelAvailability: allowedActions?.canUpdateSalesChannelAvailability ?? false,
    isLoading,
    isFetching,
  };
};
